import * as radiusDesignTokens from './radius';

export const shape = {
  ...radiusDesignTokens,
};
